/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  DocumentFolder,
  DocumentFolderFromJSON,
  DocumentFolderFromJSONTyped,
  DocumentFolderToJSON
} from './DocumentFolder'

/**
 *
 * @export
 * @interface CreateDocumentFolderResponseData
 */
export interface CreateDocumentFolderResponseData {
  /**
   *
   * @type {DocumentFolder}
   * @memberof CreateDocumentFolderResponseData
   */
  documentFolder?: DocumentFolder
}

export function CreateDocumentFolderResponseDataFromJSON(json: any): CreateDocumentFolderResponseData {
  return CreateDocumentFolderResponseDataFromJSONTyped(json, false)
}

export function CreateDocumentFolderResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateDocumentFolderResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    documentFolder: !exists(json, 'document_folder') ? undefined : DocumentFolderFromJSON(json['document_folder'])
  }
}

export function CreateDocumentFolderResponseDataToJSON(value?: CreateDocumentFolderResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    document_folder: DocumentFolderToJSON(value.documentFolder)
  }
}
